// Load data by GID function
import {PG_REST_URL} from "./Constants";

export function restLoadDetailItemsData(gid) {
    return fetch(PG_REST_URL + '/tab_catalog?gid=eq.' + gid + '&price=gt.0',
        {
            method: 'GET',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            }
        })
        .then(response => response.json())
}

// Load data by ParentID function
export function restLoadDetailData(ParentID) {
    return fetch(PG_REST_URL + '/tab_group?ParentID=eq.' + ParentID,
        {
            method: 'GET',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            }
        })
        .then(response => response.json())
}
